/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { LedgerItemType } from './LedgerItemType.js';
import {
    LedgerItemTypeFromJSON,
    LedgerItemTypeFromJSONTyped,
    LedgerItemTypeToJSON,
} from './LedgerItemType.js';
import type { StatementMatchUpdate } from './StatementMatchUpdate.js';
import {
    StatementMatchUpdateFromJSON,
    StatementMatchUpdateFromJSONTyped,
    StatementMatchUpdateToJSON,
} from './StatementMatchUpdate.js';

/**
 * 
 * @export
 * @interface LedgerItemUpdate
 */
export interface LedgerItemUpdate {
    /**
     * 
     * @type {string}
     * @memberof LedgerItemUpdate
     */
    uuid?: string;
    /**
     * 
     * @type {LedgerItemType}
     * @memberof LedgerItemUpdate
     */
    type?: LedgerItemType;
    /**
     * 
     * @type {string}
     * @memberof LedgerItemUpdate
     */
    reason?: string;
    /**
     * 
     * @type {Array<StatementMatchUpdate>}
     * @memberof LedgerItemUpdate
     */
    statementMatches?: Array<StatementMatchUpdate>;
}

/**
 * Check if a given object implements the LedgerItemUpdate interface.
 */
export function instanceOfLedgerItemUpdate(value: object): boolean {
    return true;
}

export function LedgerItemUpdateFromJSON(json: any): LedgerItemUpdate {
    return LedgerItemUpdateFromJSONTyped(json, false);
}

export function LedgerItemUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerItemUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'type': json['type'] == null ? undefined : LedgerItemTypeFromJSON(json['type']),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'statementMatches': json['statementMatches'] == null ? undefined : ((json['statementMatches'] as Array<any>).map(StatementMatchUpdateFromJSON)),
    };
}

export function LedgerItemUpdateToJSON(value?: LedgerItemUpdate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'uuid': value['uuid'],
        'type': LedgerItemTypeToJSON(value['type']),
        'reason': value['reason'],
        'statementMatches': value['statementMatches'] == null ? undefined : ((value['statementMatches'] as Array<any>).map(StatementMatchUpdateToJSON)),
    };
}

